import React from "react";
import { Redirect } from "react-router-dom";
import config from "../config";

const isAuthenticated = () => {
  const user = localStorage.getItem("userappret");
  return user ? true : false;
};

const isAdmin = () => {
  const user = JSON.parse(localStorage.getItem("userappret"));
  if (user.roleName === "admin") return true;
  else return false;
};

const redirectToRoleHome = () => {
  const user = JSON.parse(localStorage.getItem("userappret"));
  // if (user.roleName === 'admin') return true;
  switch (user.roleName) {
    case "admin":
      return <Redirect to="/admin/operadores-retiro" />;

    case "cdadmin":
      return <Redirect to="/admin/recepcion" />;

    case "seller":
      return <Redirect to="/admin/consultarLPN" />;

    case "mkp":
      return <Redirect to="/admin/crearLPN" />;

    case "backoffice":
      return <Redirect to="/admin/solicitud-evidencias" />;

    case "pickuppointop":
      return <Redirect to="/home" />;

    case "carrier":
      return <Redirect to="/home" />;

    case "RecepcionCD":
      return <Redirect to="/return" />;

    default:
      return <Redirect to="/login" />;
  }
};

const getRoleHomePath = () => {
  const user = JSON.parse(localStorage.getItem("userappret"));
  // if (user.roleName === 'admin') return true;
  switch (user.roleName) {
    case "admin":
      return "/admin/operadores-retiro";
    case "cdadmin":
      return "/admin/recepcion";
    case "seller":
      return "/admin/consultarLPN";
    case "mkp":
      return "/admin/crearLPN";
    case "backoffice":
      return "/admin/solicitud-evidencias";
    case "pickuppointop":
      return "/home";
    case "carrier":
      return "/home";
    case "RecepcionCD":
      return "/return";
    default:
      return "/login";
  }
};

const userRoles = {
  admin: "admin",
  carrier: "carrier",
  RecepcionCD: "RecepcionCD",
  pickuppointop: "pickuppointop",
  seller: "seller",
  mkp: "mkp",
  cdadmin: "cdadmin",
  backoffice: "backoffice",
};

// función de agregar tiempo cuando inicie el Login
const addTime = (time) => {
  let now = new Date();
  // We add "x" time to now, format (min) * (seg) * 1000
  now = new Date(now.getTime() + (time - 1) * 60 * 1000); // time - 1, -1 minute
  // This is the time token expires
  const expireTime = now.getTime();
  // First we save in local state
  // setTimer(expireTime);
  // Then in local storage
  const timeString = String(expireTime);
  console.log("expira es", timeString);
  localStorage.setItem("time", timeString);
  return expireTime;
};

export default {
  isAuthenticated,
  userRoles,
  isAdmin,
  redirectToRoleHome,
  getRoleHomePath,
  addTime,
};
